<!-- eslint-disable -->
<template lang="pug">
    .interactive-place
        .interactive-place__font-size-scaling-bar
            input.scaling-bar.cr-slider(
                type='range',
                @change="resizeText($event)",
                :step='stepFontSize',
                :min='minFontSize',
                :max='Math.floor(maxFontSize)',
                :value='fontSize'
            )
            .scale-text-info {{ $i18n.t('trainer.trainer_game_shutter_scale', {element: scaleElement}) }}
        .buttons
            cs-button(
                pattern="primary-outline"
                @click="$emit('doneWithPreparing')"
            ) {{ $i18n.t('common.common_button_done') }}
        .test-text-container(
            :style="testTextContainerStyles"
            @wheel="!isItemColumnMode && handleScroll($event)"
            @mousedown="handleMouseDown($event)"
            @mouseleave="isDown = false"
            @mouseup="isDown = false"
            @mousemove="handleMouseMove($event)"
        )
            .test-text-container__row(
                :class="rowsName"
                v-for="word in displayedTestLines"
                ref="wordLine"
            )
                span(:class="{'inverted-word': invertedItem}") {{ word }}
</template>

<script>
    /*eslint-disable*/
    import textScrollMixin from '../../../utils/trainer/textScroll'

    const LINE = "Тестовая строка. ";
    const LINE_REPETITIONS_NUMBER = 15;

    export default {
        props: {
            elementName: String,
            isGameTuned: Boolean,
            isFromShutter: {
                type: Boolean,
                default: false,
            },
            invertedItem: {
                type: Boolean,
                default: false,
            },
            isItemColumnMode: {
                type: Boolean,
                default: false,
            },
            amountOfWords: {
                type: Number,
                default: 10,
            },
            rowsName: String,
            fontSize: [Number, String],
            scaleElement: {
                type: String,
                default () {
                    return this.$i18n.tc('trainer.trainer_gamePlayBox_words');
                }
            },
            isAnagrams: {
                type: Boolean,
                default: false
            },
            isAnagramsWithTime: {
                type: Boolean,
                default: false
            },
            isMobilePhone: {
                type: Boolean,
                default: false,
            },
            isTextMode: {
                type: Boolean,
                default: false
            },
            shutterAmountOfWordsInRow: {
                type: Number,
                default: 0
            }
        },
        mixins: [textScrollMixin],
        data () {
            return {
                windowWidth: 0,
            }
        },
        created () {
            document.addEventListener("keydown", this.doneOnEnter);
        },
        mounted () {
            this.windowWidth = window.innerWidth;
            this.gameBoxName = 'test-text-container';
            let testTextContainerHeight = window.innerHeight - document.querySelector('.app-container__header').clientHeight -
                    document.querySelector('.interactive-place__font-size-scaling-bar').clientHeight -
                    document.querySelector('.buttons').clientHeight - window.innerHeight * 0.23;
            document.querySelector('.test-text-container').style.height = testTextContainerHeight + 'px';
            this.$emit('setFontSize', this.minFontSize);
        },
        methods: {
            resizeText (event) {
                let fontSize = event.target.value;
                if(!this.isAnagramsWithTime) {
                    this.element.style.fontSize = fontSize + 'px'
                } else {
                    if (this.isMobilePhone) {
                        this.element.style.fontSize = fontSize * 1.4 + 'px'
                    } else {
                        this.element.style.fontSize = fontSize * 4 + 'px'
                    }
                }
                this.$emit('setFontSize', fontSize);
                if (this.isFromShutter) {
                    let height, width;
                    [height, width] = !this.isGameTuned ? [this.$refs.wordLine[0].clientHeight, this.$refs.wordLine[0].clientWidth] : [0, 0];
                    this.$emit('setHeight', height, width);
                }
            },
            doneOnEnter (event) {
                if (event.keyCode === 13) {
                    document.removeEventListener('keydown', this.doneOnEnter);
                    this.$emit('doneWithPreparing')
                }
            },
        },
        computed: {
            element () {
                if (this.isGameTuned) {
                    return document.querySelector(`.${this.elementName}`);
                }
                return document.querySelector('.test-text-container');
            },
            displayedTestLines () {
                if (!this.isGameTuned) {
                    let line_number = this.isItemColumnMode ? this.amountOfWords : LINE_REPETITIONS_NUMBER;
                    let text = LINE.repeat(line_number);
                    let displayedLines = [];
                    if (this.isItemColumnMode) {
                        displayedLines = _.take(text.match(/[^.!?]+[.!?"'»]+/g), this.amountOfWords);
                    } else {
                        displayedLines = _.chunk(text.split(" "), this.amountOfWords);
                        displayedLines = _.map(displayedLines, arr => arr.join(' '));
                    }
                    return displayedLines;
                }
                return [];
            },
            testTextContainerStyles() {
                if (!(this.isAnagrams && !this.isMobilePhone)) {
                    return 'font-size: ' + this.minFontSize + 'px';
                } else {
                    return 'font-size: 144px'
                }

                // return !(this.isAnagrams && !this.isMobilePhone) ? 'font-size: 18px' : 'font-size: 144px'
            },
            stepFontSize() {
                if (this.isFromShutter) {
                    return !this.isTextMode && 4 || this.isTextMode && 1;
                }
            },
            minFontSize() {
                if (this.isFromShutter) {
                    if (this.windowWidth < 1440) {
                        return !this.isTextMode && 36 || this.isTextMode && 12;
                    } else if (this.windowWidth < 1600) {
                        return !this.isTextMode && 36 || this.isTextMode && 16;
                    } else {
                        return !this.isTextMode && 44 || this.isTextMode && 18;
                    }
                }
            },
            maxFontSize() {
                if (this.isFromShutter) {
                    let multiplier;
                    if (this.isTextMode) {
                        if (this.shutterAmountOfWordsInRow > 0 && this.shutterAmountOfWordsInRow <= 5) {
                            multiplier = 2.6;
                        } else if (this.shutterAmountOfWordsInRow > 5 && this.shutterAmountOfWordsInRow <= 10) {
                            multiplier = 1.5;
                        } else {
                            multiplier = 1;
                        }
                    }
                    if (this.windowWidth < 1200) {
                        return !this.isTextMode && 100 || this.isTextMode && 12 * multiplier;
                    } else if (this.windowWidth < 1366) {
                        return !this.isTextMode && 112 || this.isTextMode && 15 * multiplier;
                    } else if (this.windowWidth < 1440) {
                        return !this.isTextMode && 132 || this.isTextMode && 17 * multiplier;
                    } else if (this.windowWidth < 1600) {
                        return !this.isTextMode && 144 || this.isTextMode && 19 * multiplier;
                    } else if (this.windowWidth < 1800 && this.isTextMode) {
                        return 21 * multiplier;
                    } else if (this.windowWidth <= 1920 && this.isTextMode) {
                        return 25 * multiplier;
                    } else if (this.windowWidth < 1920) {
                        return 164;
                    } else {
                        return !this.isTextMode && 196 || this.isTextMode && 27 * multiplier;
                    }
                }
            }
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.doneOnEnter)
        },
    }
</script>

<style lang="scss" scoped>
    .buttons {
        margin-bottom: 30px;
        text-align: center;
    }

    .scale-text-info {
        font-size: 18px;
        @include media($lg) {
            font-size: 26px;
        }
        @include media($xlg) {
            font-size: 32px;
        }
    }

    .scaling-bar {
        -webkit-appearance: none;
        width: 50%;
        background: transparent;
        margin: 24px 0;
        &:focus {
            outline: none;
        }
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: $hsl-color-green-58;
            margin-top: -6px;
            cursor: pointer;
        }
        &::-moz-range-thumb {
            -webkit-appearance: none;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-ms-thumb {
            -webkit-appearance: none;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-webkit-slider-runnable-track {
            width: 100%;
            height: 6px;
            cursor: pointer;
            background: #eaeaea;
            border-radius: 2px;
        }
    }

    .interactive-place {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .interactive-place__font-size-scaling-bar {
        padding-top: 12px;
        text-align: center;
        margin-bottom: 28px;
    }

    .test-text-container {
        text-align: center;
        font-size: 18px;
        white-space: normal;
        overflow-x: hidden;
        overflow-y: auto;
        cursor: pointer;
        user-select: none;
        height: 150px;
        @include media($xlg) {
            height: 244px;
        }
        @include media($xl) {
            height: 440px;
        }
        @media screen and (min-width: 1680px) {
            height: 540px;
        }
        @include media($xxl) {
            height: 620px;
        }
        @include scrollbar;
    }

    .inverted-word {
        display: inline-block;
        transform: rotate(180deg);
    }
</style>
